/**
 * Created by natalia.petrov on 8/1/2017.
 */
import initialState from '../store/initialstate'
import C from  '../constants/news';

export default (state = initialState().news, action = null) => {
    // debugger;
    switch(action.type){
        case C.GET_NEWS:
            return state.set(C.NEWS, {data:action.payload});
        case C.UPDATE_NEWS_CONTEXT:
            return state.set(C.NEWS, {...state.get(C.NEWS), ...action.payload});
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./reducers/news.js